import { Battery, Wifi, Signal } from "lucide-react";

/**
 * A phone-shaped bezel wrapper for showing mobile app screens
 * inside a web prototype. children fills the phone screen.
 */
export default function PhoneFrame({ children, label = "iPhone" }) {
  return (
    <div className="phone-frame rammy-shadow-lg" data-testid="phone-frame">
      <div className="phone-screen relative">
        {/* Status bar */}
        <div className="absolute top-0 left-0 right-0 h-9 z-30 flex items-center justify-between px-6 text-[11px] font-medium text-[#1A1C1E]/80">
          <span className="font-mono">9:41</span>
          <div className="absolute left-1/2 -translate-x-1/2 top-2 w-24 h-6 rounded-full bg-[#0B0C10]" />
          <div className="flex items-center gap-1.5">
            <Signal size={12} />
            <Wifi size={12} />
            <Battery size={14} />
          </div>
        </div>
        <div className="pt-9 h-full">{children}</div>
      </div>
    </div>
  );
}
